// extracted by mini-css-extract-plugin
export default {"headerNavigation":"HeaderNavigation_headerNavigation__uHews","menu":"HeaderNavigation_menu__v+oSc"};